import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function VisitasChart({ visitas, agentsMap }) {
  const agentCounts = visitas.reduce((acc, visita) => {
    // Usa o ID da visita para encontrar o nome do agente no mapa.
    // Se não encontrar, usa o email como uma alternativa segura.
    const agentName = agentsMap[visita.idAgente] || visita.emailAgente;

    // Usa o NOME do agente como chave para a contagem, em vez do email.
    acc[agentName] = (acc[agentName] || 0) + 1;
    return acc;
  }, {});

  const data = {
    labels: Object.keys(agentCounts),
    datasets: [
      {
        label: 'Nº de Visitas',
        data: Object.values(agentCounts),
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: { display: false },
    },
    scales: {
        y: { beginAtZero: true }
    }
  };

  return <Bar options={options} data={data} />;
}

export default VisitasChart;